export default "__VITE_ASSET__DGgYEbNz__"